import React from "react";
import { Link } from "react-router-dom";

const StockMarketContentTwo = () => {
  return (
    <div className="how__work__market">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="thumb-left">
              <div className="content-left">
                <h2>Understand What Moves the Markets</h2>

                <p>
                  Understand the core elements influencing stock prices, from
                  company performance to global economic shifts and make
                  smarter, more informed trading decisions.
                </p>
              </div>
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/markets/stocks_cfd/stocks_2.png"
                }
                alt="computer images"
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="content-right">
              <h3>Company Performance</h3>
              <p>
                Quarterly earnings reports, revenue growth, and new product
                launches can heavily influence investor sentiment. Strong
                performance often leads to stock price appreciation, while
                missed expectations can drive sharp declines.
              </p>
              <hr className="black-line" />
              <h3>Economic Indicators</h3>
              <p>
                GDP growth, employment data, and inflation rates directly impact
                market confidence. When economic indicators strengthen,
                investors typically shift toward equities in anticipation of
                higher corporate profits.
              </p>
              <hr className="black-line" />
              <h3>Interest Rates</h3>
              <p>
                Changes in interest rates by central banks affect borrowing
                costs and investor appetite. Lower rates tend to support stock
                market growth, while rate hikes can pressure equity valuations.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockMarketContentTwo;
